import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';

import { StoryConnManager } from 'apps/story/main/appManager';

import { StoriesQuery } from 'apps/story/gql';

import { FeaturedStoriesQuery } from 'apps/home/featured/gql';

export class DiscoverStoriesManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);

    this.variables = new Variables({
      // featured Stories
      featuredStorysCursor: () => null,
      featuredStorysCount: () => {
        if (
          this.featuredStoriesConn.arrayApp.length >
          this.featuredStoriesConn.initialBatchSize
        ) {
          return this.featuredStoriesConn.batchSize;
        }
        return this.storiesConn.initialBatchSize;
      },
      featuredStorysSortBy: () => this.storiesConn.sortBy,
      // all stories
      storiesCursor: () => null,
      storiesCount: () => {
        if (
          this.storiesConn.arrayApp.length > this.storiesConn.initialBatchSize
        ) {
          return this.storiesConn.batchSize;
        }
        return this.storiesConn.initialBatchSize;
      },
      storiesSortBy: () => this.storiesConn.sortBy,
    });
    this.featuredStoriesConn = new StoryConnManager(this, {
      contains: ['featured_in', 'featured_stories'],
      loadMoreQuery: FeaturedStoriesQuery,
      initialBatchSize: 4,
      sortOptions: [],
    });
    this.storiesConn = new StoryConnManager(this, {
      sortBy: 'recent',
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['-likes', i18next.t('Likes')],
        ['pageviews', i18next.t('Views')],
      ],
      filterBy: [['Story.canAppearOnHome', 'true']],
      initialBatchSize: 12,
      loadMoreQuery: StoriesQuery,
    });
    this.StoriesQuery();
  }

  @action StoriesQuery = () => {
    this.storiesConn.loadMore();
    this.featuredStoriesConn.loadMore();
  };
}
